// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__145Yc","inputWrap":"Table_inputWrap__1mlDG","col":"Table_col__8ZixO","bmiTooltip":"Table_bmiTooltip__1O93v"};